export default {
  address_street: '75 Route de Mittelhausbergen',
  address_city: '67200 Strasbourg',
  phone: '0695429513',
  email: 'admin@reboot-immobilier.com',
};
